import { useMemo } from 'react';

import { Asset } from '@shared/api';

import { useEligibleForLoansAssets } from '@hooks/Assets/useEligibleForLoansAssets';

import { DateTime } from 'luxon';
import { AppFeature, useIsFeatureEnabled } from 'src/config';

const useLoansFeaturePromoBanner = (asset?: Asset) => {
  const { isFeatureEnabled } = useIsFeatureEnabled();
  const loansEnabled = isFeatureEnabled(AppFeature.CryptoBackedLoans);

  const eligibleForLoansAssets = useEligibleForLoansAssets();
  // Loans promo banner will only be shown if the asset is eligible for loans and the feature is enabled
  const assetEligibleForLoan = useMemo(
    () => eligibleForLoansAssets.findIndex((a) => asset?.code === a.code) > -1,
    [asset, eligibleForLoansAssets, loansEnabled],
  );

  // Feature promo banner should only be shown for the first 3 months (approx 90days) after the feature launch
  const isWithin3MonthsOfFeatureLaunch = useMemo(() => {
    // TODO: update this date to actual feature launch date
    const date = DateTime.fromFormat('2025-06-01', 'yyyy-MM-dd');
    const addedDatePlus3Months = date.plus({ months: 3 }).toMillis();
    return addedDatePlus3Months > DateTime.now().toMillis();
  }, []);

  const showLoansPromoBanner = useMemo(() => {
    if (asset && !assetEligibleForLoan) return false;

    return loansEnabled && isWithin3MonthsOfFeatureLaunch;
  }, [asset, loansEnabled, assetEligibleForLoan, isWithin3MonthsOfFeatureLaunch]);

  return {
    showLoansPromoBanner,
  };
};

export { useLoansFeaturePromoBanner };
